import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '@/stores'
import type { ArticleBrand } from '@/utils/types'

export default function useSeo(brand: ArticleBrand) {
  const globalStore = useGlobalStore()

  const title = `${brand?.seo?.meta_title || brand?.subject}｜代理品牌｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = brand?.seo?.meta_description
  const url = `/brand/${brand?.seo?.meta_slug || brand?.id}`

  globalStore.setBreadcrumbs([
    { title: '代理品牌', isActive: false, url: '/brands' },
    { title: brand?.subject, isActive: true, url }
  ])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description,
    ogImage: brand?.seo?.og_image?.link,
    keywords: brand?.seo?.meta_keywords?.join(',')
  })

  let meta = []
  if (!brand?.status) {
    meta.push({ hid: 'robots', name: 'robots', content: 'noindex' })
  }

  useHead({
    link: [
      {
        rel: 'canonical',
        href: `${import.meta.env.VITE_DOMAIN}${url}`
      }
    ],
    meta: meta
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '代理品牌',
            item: `${import.meta.env.VITE_DOMAIN}/brands`
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: brand?.subject,
            item: `${import.meta.env.VITE_DOMAIN}${url}`
          }
        ]
      }
    ]
  })
}
